import React, { useEffect, useState } from "react";

import InputComponent from "components/InputG";
import RadioComponent from "components/RadioG";
import * as Styles from "./styles";

interface Props {
  onClose: () => void;
  setOpenModalEscolherOpcao: (val: boolean) => void;
  setSelectedOption: (val: string) => void;
  setLeadCode: (val: string) => void;
  leadCode: string;
  selectedOption: string;
  dataResumo: any;
  dataVincularCodigo: any;
  refetchVincularCodigo: () => void;
  isLoadingVincularCodigo: boolean;
  selectedItem: any;
  isErrorVincularCodigo: boolean;
  setLeadProducts?: (val: {
    label: string;
    value: string;
    idLeadCorretor: string;
  }) => void;
}

const Footer: React.FC<Props> = ({
  onClose,
  setOpenModalEscolherOpcao,
  setSelectedOption,
  setLeadCode,
  leadCode,
  selectedOption,
  dataResumo,
  dataVincularCodigo,
  refetchVincularCodigo,
  isLoadingVincularCodigo,
  selectedItem,
  isErrorVincularCodigo,
  setLeadProducts,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (
      isSubmitting &&
      !isLoadingVincularCodigo &&
      !isErrorVincularCodigo &&
      dataVincularCodigo
    ) {
      setIsSubmitting(false);

      if (setLeadProducts) {
        setLeadProducts({
          label: dataVincularCodigo?.nomeLead || "",
          value: dataVincularCodigo?.idLead,
          idLeadCorretor: dataVincularCodigo?.idLeadCorretor,
        });
      }

      if (dataResumo?.simuladorAssociativo === false) {
        window.location.pathname = `lead-detail/${dataVincularCodigo?.idLeadCorretor}/${dataVincularCodigo?.idLead}/repasse-chaves/${selectedItem?.idUnidade}`;
        onClose();
      } else if (dataResumo?.simuladorAssociativo === true) {
        setOpenModalEscolherOpcao(true);
        onClose();
      }
    }
  }, [
    isSubmitting,
    isLoadingVincularCodigo,
    isErrorVincularCodigo,
    dataVincularCodigo,
    dataResumo,
    selectedItem,
    onClose,
    setOpenModalEscolherOpcao,
    setLeadProducts,
  ]);

  const onSubmit = async () => {
    setIsSubmitting(true);
    await refetchVincularCodigo();
  };

  return (
    <>
      <Styles.Container
        style={{
          justifyContent: "start",
          marginLeft: "10px",
          marginBottom: "10px",
        }}
      >
        <RadioComponent
          label="Código do Lead"
          value={"1"}
          onChange={(e) => {
            setSelectedOption(e.target.value);
            setLeadCode("");
          }}
          checked={selectedOption === "1"}
        />
        <RadioComponent
          label="Lead Coringa"
          value={"2"}
          onChange={(e) => {
            setSelectedOption(e.target.value);
            setLeadCode("");
          }}
          checked={selectedOption === "2"}
        />
      </Styles.Container>
      {selectedOption === "1" && (
        <Styles.Container>
          <InputComponent
            value={leadCode}
            placeholder="Insira o código do Lead"
            onChange={(e) => {
              setLeadCode(e.target.value);
            }}
          />
        </Styles.Container>
      )}
      <Styles.SecondContainer>
        <Styles.Button onClick={onClose}>
          <Styles.LightTextBlue>Voltar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          disabled={
            (leadCode === "" && selectedOption === "1") ||
            isLoadingVincularCodigo
          }
          onClick={() => onSubmit()}
        >
          <Styles.LightText>Continuar</Styles.LightText>
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
